export default __webpack_public_path__ + "static/media/cross.57a9dd1c.svg";